export default __webpack_public_path__ + "static/media/mouse-03.9fabc4ce.jpg";